
import { Options, Vue } from "vue-class-component";
import EventGuestHeader from "./components/EventGuestHeader.vue";
import EventGuestImage from "./components/EventGuestImage.vue";
import EventGuestTitleBar from "./components/EventGuestTitleBar.vue";
import TextField from "./components/TextField.vue";
import EventSchedule from "./components/EventSchedule.vue";
import Copyrights from "./components/Copyrights.vue";
import SocialMediaButtons from "./components/SocialMediaButtons.vue";
import Contact from "./components/Contact.vue";
import Media from "./components/Media.vue";
// @ts-ignore
import guest from "./data/guestData.js";
import { useRoute } from "vue-router";
import { sortedDays } from "./data/functions";

@Options({
  components: {
    EventGuestHeader,
    EventGuestImage,
    EventGuestTitleBar,
    TextField,
    EventSchedule,
    Copyrights,
    SocialMediaButtons,
    Contact,
    Media,
  },
  props: {
    id: String,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
})
export default class Guest extends Vue {
  route = useRoute();
  sortedDays = sortedDays;
  id = this.route.params.id;
  guest = // @ts-ignore
    guest.filter((guest) => guest._id === this.id)?.[0];
  name: string = this.guest.name;
  image: string = this.guest.image;
  // @ts-ignore
  twitter?: string = this.guest.links.twitter;
  instagram?: string = this.guest.links.instagram;
  facebook?: string = this.guest.links.facebook;
  deezer?: string = this.guest.links.deezer;
  spotify?: string = this.guest.links.spotify;
  // @ts-ignore
  soundcloud?: string = this.guest.links.soundcloud;
  youtube?: string = this.guest.links.youtubeChannel;
  // @ts-ignore
  telephone?: string = this.guest.phone;
  // @ts-ignore
  email?: string = this.guest.email;
  website?: string = this.guest.website
    ? this.guest.website
    : this.guest.links.website;
  copyright?: string = this.guest.copyright;
  description?: string = this.guest.description;
  country?: string = this.guest.origin;
  tags: string[] = this.guest.tags;
  events: object[] = this.guest.events.sort(
    // @ts-ignore
    (a: any, b: any) => new Date(a.day) - new Date(b.day)
  );
}
